// extracted by mini-css-extract-plugin
export default {"payoutFrequency":"Rt3HAtLlbyE7xi9fG7dw","savePayoutChanges":"SF42_6gqFn87bxVPhe4W"};